// 기존 dataset으로부터 DataHeader 만들기
//   flag : i=insert u=update d=insert+update a=all
export function makeDataHeader(dataset) {
    var head = "";
    var dlmtr = ",";
    var objLen = "";
    var obj, colDec;
console.log("makeDataHeader");
    for (var i = 1; i <= dataset.CountColumn; i++) {

        objLen  = dataset.ColumnSize(i);
        colDec = dataset.ColumnDec(i);// 소수점 자리수 추가 by lkh 2008.03.26
        if (i === 1) {
            if ( dataset.ColumnType(i) === 1 )
            {
                head += dataset.ColumnID(i) + ":STRING(" + objLen + ")";
            } else if ( dataset.ColumnType(i) === 2 )
            {
                head += dataset.ColumnID(i) + ":INTEGER(" + objLen + ")";
            } else if ( dataset.ColumnType(i) === 3 )
            {
                if (colDec === 0) head += dataset.ColumnID(i) + ":DECIMAL(" + objLen + ")";
                else head += dataset.ColumnID(i) + ":DECIMAL(" + objLen + "." + colDec + ")";
            } else if ( dataset.ColumnType(i) === 4 )
            {
                head += dataset.ColumnID(i) + ":DATE(" + objLen + ")";
            } else if ( dataset.ColumnType(i) === 5 )
            {
                head += dataset.ColumnID(i) + ":URL(" + objLen + ")";
            }
        } else {
            if ( dataset.ColumnType(i) === 1 )
            {
                head += dlmtr + dataset.ColumnID(i) + ":STRING(" + objLen + ")";
            } else if ( dataset.ColumnType(i) === 2 )
            {
                head += dlmtr + dataset.ColumnID(i) + ":INTEGER(" + objLen + ")";
            } else if ( dataset.ColumnType(i) === 3 )
            {
                if (colDec === 0) head += dlmtr + dataset.ColumnID(i) + ":DECIMAL(" + objLen + ")";
                else head += dlmtr + dataset.ColumnID(i) + ":DECIMAL(" + objLen + "." + colDec + ")";
            } else if ( dataset.ColumnType(i) === 4 )
            {
                head += dlmtr + dataset.ColumnID(i) + ":DATE(" + objLen + ")";
            } else if ( dataset.ColumnType(i) === 5 )
            {
                head += dlmtr + dataset.ColumnID(i) + ":URL(" + objLen + ")";
            }
        }
    }
console.log("makeDataHeader:" + head);
    return head;
}
